import loadingAnimation from '@/assets/branding/loading-animation.webm';

export function LoadingSpinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <svg
      className={`animate-spin text-primary-600 ${sizes[size]}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
}

interface LoadingAnimationProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const ANIMATION_SIZES = {
  sm: 'h-16 w-16',
  md: 'h-24 w-24',
  lg: 'h-40 w-40',
  xl: 'h-56 w-56',
};

// Branded loading animation (webm). Autoplays muted+looped so it works on
// every browser including iOS Safari, which blocks unmuted autoplay.
export function LoadingAnimation({ size = 'lg', className }: LoadingAnimationProps) {
  return (
    <video
      className={`${ANIMATION_SIZES[size]} object-contain ${className ?? ''}`}
      src={loadingAnimation}
      autoPlay
      loop
      muted
      playsInline
      aria-label="Loading"
    />
  );
}

export function LoadingPage() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <LoadingAnimation size="lg" />
    </div>
  );
}

// Full-viewport branded splash. Used by the auth gate while we resolve
// the session, and any other "the whole app is waiting" state.
export function LoadingScreen() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <LoadingAnimation size="xl" />
    </div>
  );
}
